export interface LatLng {
    lat: number,
    lng: number
}

// export const CHICAGO: LatLng = {lat: 41.939292, lng: -87.650396}
export const HAWAII: LatLng = {lat: 21.400568089738343, lng: -158.17095282965232}
export const DEFAULT_ZOOM = 16
